import messages from '../messages/en';

export default {
    locale: 'en',
    messages
};